/* =============================
AKE (Multi-API) Catalog (Standard)
Auto-generated from config
Pattern: unified
============================= */
(function () {
const API_SOURCES = {
'naonao': {
name: 'Naonao Source',
url: 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/ake-multi-proxy?source=naonao',
enabled: true,
priority: 1,
idPrefix: 'AKE01',
prefixes: [],
unwanted: new Set(['美欧','亚服','欧美','SEA','Asia','Global','America','Europe','HMT','HK,TW,MAC','男角色','女角色','Gender','Server','Level','男','女']),
nameKey: 'name',
idKey: 'id',
imageKey: 'img',
root: 'results',
extra_data: {}
},
'kikiyx': {
name: 'Kikiyx Source',
url: 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=ake',
enabled: true,
priority: 2,
idPrefix: 'AKE02',
prefixes: [],
unwanted: new Set(['美欧','亚服','欧美','SEA','Asia','Global','America','Europe','HMT','HK,TW,MAC','男角色','女角色','Gender','Server','Level','男','女']),
nameKey: 'name',
idKey: 'id',
imageKey: 'img_url',
root: 'results',
extra_data: {}
},
'zxw': {
name: 'Zxw Source',
url: 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/ake-multi-proxy?source=zxw',
enabled: true,
priority: 3,
idPrefix: 'AKE03',
prefixes: [],
unwanted: new Set(['美欧','亚服','欧美','SEA','Asia','Global','America','Europe','HMT','HK,TW,MAC','男角色','女角色','Gender','Server','Level','男','女']),
nameKey: 'name',
idKey: 'id',
imageKey: 'img',
root: 'results',
extra_data: {}
}
};

const NAONAO_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/ake-multi-proxy?source=naonao';
const KIKIYX_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/wuwa-multi-proxy?source=ake';
const ZXW_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/ake-multi-proxy?source=zxw';

let selected = {}; /* Keyed by Display Name */

/* Lazy Loading State */
let allSearchResults = [];
let renderedCount = 0;
const BATCH_SIZE = 24;
let resultObserver = null;

/* ====== Dynamic Partials Inclusion ====== */
/* SCROLL LOGIC */
const initResultObserver = () => {
if (resultObserver) resultObserver.disconnect();
resultObserver = new IntersectionObserver((entries) => {
if (entries[0].isIntersecting && renderedCount < allSearchResults.length) { renderBatch(); } }, { rootMargin: '200px'
    }); };
/* UI UPDATES */
const updateSelectedUI = () => {
const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
const el = document.querySelector("#selectedCount");
if (el) el.textContent = totalCount;
};

const scrollToResults = () => {
document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const updateThumbDisplay = (thumb, key) => {
const count = selected[key]?.count || 0;
const existingBadge = thumb.querySelector('.count-badge');
if (count > 0) {
thumb.classList.add('selected');
if (existingBadge) existingBadge.textContent = count;
else {
const b = document.createElement('div');
b.className = 'count-badge';
b.textContent = count;
thumb.querySelector('.thumb-img-container').appendChild(b);
}
} else {
thumb.classList.remove('selected');
if (existingBadge) existingBadge.remove();
}
};
/* CLIPBOARD */
const showToast = () => {
const toast = document.querySelector("#toast");
if (!toast) return;
toast.classList.remove('hidden', 'show');
toast.offsetHeight;
toast.classList.add('show');
setTimeout(() => {
toast.classList.remove('show');
setTimeout(() => toast.classList.add('hidden'), 300);
}, 3000);
};

const copyToClipboard = text => {
if (navigator.clipboard) {
navigator.clipboard.writeText(text).then(showToast).catch(() => fallbackCopy(text));
} else fallbackCopy(text);
};

const fallbackCopy = text => {
const ta = document.createElement('textarea');
ta.value = text;
ta.style.cssText = 'position:fixed;left:-9999px';
document.body.appendChild(ta);
ta.select();
try {
document.execCommand('copy');
showToast();
} catch (e) { }
document.body.removeChild(ta);
};
/* HELPERS */
/* HELPERS */
const escapeHtml = s => String(s || '').replace(/[&<>"]|'/g, m => ({
    '&': '&amp;',
    '<': '&lt;' , '>' : '&gt;' , '"' : '&quot;' , "'" : '&#39;' }[m])); const normalizeString=(name, prefixes)=> {
        if (!name) return '';
        let n = String(name).trim();
        if (prefixes) prefixes.forEach(p => { if (n.startsWith(p)) n = n.slice(p.length); });
        return n;
        };

        const getResultsArray = (payload, apiId) => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;

        const config = API_SOURCES[apiId];
        /* Try mapping root first */
        if (config && config.root) {
        const parts = config.root.split('.');
        let cur = payload;
        for (const p of parts) if (cur) cur = cur[p];
        if (Array.isArray(cur)) return cur;
        }

        /* Try common patterns (including robustness fix from ZXW) */
        return payload.results || payload.items || payload.data?.items || payload.data?.records || payload.data ||
        (Array.isArray(payload.c) ? payload.c : []);
        };

        const buildHasMap = (acc) => {
        let has = {};
        if (acc.deck_info) {
        try {
        has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info;
        } catch (e) { }
        } else if (acc.items) {
        acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
        } else if (acc.cardList && Array.isArray(acc.cardList)) {
        acc.cardList.forEach(c => {
        const name = c.cardName || 'Unknown';
        has[name] = (has[name] || 0) + 1;
        });
        }
        return has;
        };

        const accountMatchesSelection = (has, selectedKeys) => {
        return selectedKeys.every(k => {
        const req = selected[k];
        return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
        });
        };
/* SETTINGS */
/*======Settings & API Registry======*/
let appSettings = { translations_json: '{}', images_json: '{}', api_toggles: {}, api_priority: {} };
const logger = {
log: (...args) => { if (appSettings.enable_debug) console.log(...args); },
warn: (...args) => { if (appSettings.enable_debug) console.warn(...args); },
error: (...args) => { console.error(...args); } /* Errors always show */
};

try {
const el = document.getElementById('catalog-settings-ake-multi');
if (el) appSettings = JSON.parse(el.textContent);

if (appSettings.api_toggles) {
Object.keys(API_SOURCES).forEach(apiId => {
if (appSettings.api_toggles.hasOwnProperty(apiId)) {
API_SOURCES[apiId].enabled = appSettings.api_toggles[apiId] === true;
}
if (appSettings.api_names && appSettings.api_names[apiId]) {
API_SOURCES[apiId].name = appSettings.api_names[apiId];
}
if (appSettings.api_priority && appSettings.api_priority.hasOwnProperty(apiId)) {
API_SOURCES[apiId].priority = parseInt(appSettings.api_priority[apiId], 10);
}
});
}
} catch (e) { }
/* TRANSLATIONS */
/*======Translations & Images======*/
let nameTranslationsMap = {};
try {
const json = JSON.parse(appSettings.translations_json || '{}');
Object.entries(json).forEach(([key, val]) => {
const standardValue = typeof val === 'string' ? val.trim() : val;
key.split('|').forEach(k => {
if (k.trim()) nameTranslationsMap[k.trim()] = standardValue;
});
});
} catch (e) { }

let customImagesMap = {};
try {
const json = JSON.parse(appSettings.images_json || '{}');
Object.entries(json).forEach(([key, val]) => {
const imageUrl = typeof val === 'string' ? val.trim() : val;
key.split('|').forEach(k => {
if (k.trim()) customImagesMap[k.trim()] = imageUrl;
});
});
} catch (e) { }

const translateName = name => nameTranslationsMap[name] || name;
const getCustomImage = name => customImagesMap[name] || null;
/* ID HANDLER */
/*======ID Transformation======*/
function privateToPublicID(privateID, source) {
    if (!privateID) return '';
    const srcConf = API_SOURCES[source];
    const prefix = srcConf?.name ? srcConf.name.replace(/\s+/g, '') : 'ACC';
    return GachaUtils.obfuscateId(privateID, prefix);
  }

function publicToPrivateID(publicID) {
    if (!publicID) return '';
    let core = publicID.trim();
    if (core.includes('----')) {
        core = core.split('----')[0];
    }
    if (core.includes('-')) {
        core = core.split('-')[1];
    } else if (core.length > 5 && (core.startsWith('WW') || core.length > 12)) {
        if (core.length >= 5) core = core.substring(2, core.length - 2);
    }
    let chars = core.split('');
    for (let i = 0; i + 1 < chars.length; i += 2) {
        const t = chars[i];
        chars[i] = chars[i + 1];
        chars[i + 1] = t;
    }
    return chars.reverse().join('');
}



/* CATALOG SPECIFIC RESOURCE FETCHER */
const loadResources = () => {
const promises = [];
{
const config = API_SOURCES['naonao'];
const url = API_SOURCES['naonao'].url + '&action=list';
if (url) {
promises.push(fetch(url).then(r => r.json()).catch(e => {
console.error('[naonao] fetch failed:', e);
return null;
}));
} else {
promises.push(Promise.resolve(API_SOURCES['naonao'].resources || []));
}
}
{
const config = API_SOURCES['kikiyx'];
const url = API_SOURCES['kikiyx'].url + '&action=list';
if (url) {
promises.push(fetch(url).then(r => r.json()).catch(e => {
console.error('[kikiyx] fetch failed:', e);
return null;
}));
} else {
promises.push(Promise.resolve(API_SOURCES['kikiyx'].resources || []));
}
}
{
const config = API_SOURCES['zxw'];
const url = API_SOURCES['zxw'].url + '&action=resource';
if (url) {
promises.push(fetch(url).then(r => r.json()).catch(e => {
console.error('[zxw] fetch failed:', e);
return null;
}));
} else {
promises.push(Promise.resolve(API_SOURCES['zxw'].resources || []));
}
}

Promise.all(promises).then(responses => {
const apiData = {};
apiData['naonao'] = getResultsArray(responses[0], 'naonao');
apiData['kikiyx'] = getResultsArray(responses[1], 'kikiyx');
apiData['zxw'] = getResultsArray(responses[2], 'zxw');
mergeRegistries(apiData);
});
};





/* CATALOG SPECIFIC REGISTRY MERGER */
const mergeRegistries = (apiData) => {
const merged = {};
{
const id = 'naonao';
const config = API_SOURCES[id];
apiData['naonao'].forEach(item => {
const rawName = item.cardName || item[config.nameKey] || item.name;
const norm = normalizeString(rawName, config.prefixes);
if (config.unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item.cardPicture || item[config.imageKey] || item.img_url || item.role_img || item.card_img || item.pic;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_naonao_id: String(item.shortName || item[config.idKey] || item.id || ''),
img: itemImg
};
} else {
merged[displayLabel]._naonao_id = String(item.shortName || item[config.idKey] || item.id || '');
if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});}
{
const id = 'kikiyx';
const config = API_SOURCES[id];
apiData['kikiyx'].forEach(item => {
const rawName = item.cardName || item[config.nameKey] || item.name;
const norm = normalizeString(rawName, config.prefixes);
if (config.unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item.cardPicture || item[config.imageKey] || item.img_url || item.role_img || item.card_img || item.pic;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_kikiyx_id: String(item.shortName || item[config.idKey] || item.id || ''),
img: itemImg
};
} else {
merged[displayLabel]._kikiyx_id = String(item.shortName || item[config.idKey] || item.id || '');
if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});}
{
const id = 'zxw';
const config = API_SOURCES[id];
apiData['zxw'].forEach(item => {
const rawName = item.cardName || item[config.nameKey] || item.name;
const norm = normalizeString(rawName, config.prefixes);
if (config.unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item.cardPicture || item[config.imageKey] || item.img_url || item.role_img || item.card_img || item.pic;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_zxw_id: String(item.shortName || item[config.idKey] || item.id || ''),
img: itemImg
};
} else {
merged[displayLabel]._zxw_id = String(item.shortName || item[config.idKey] || item.id || '');
if (!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});}

const finalRegistry = Object.values(merged).sort((a,b) => a.displayLabel.localeCompare(b.displayLabel));
window._characterImageMap = {};
finalRegistry.forEach(it => {
if (it.img) window._characterImageMap[it.displayLabel] = it.img;
});
renderFilters(finalRegistry);
};

/* FILTER RENDERER */
const renderFilters = (items) => {
const container = document.querySelector("#filters");
if (!container) return;
container.innerHTML = '';

items.forEach(it => {
const thumb = document.createElement('div');
const displayLabel = it.displayLabel;

/* Resolve custom image: try normalized name first (old behavior), then standard label, then raw */
let imgSrc = getCustomImage(it.normName) || getCustomImage(it.displayLabel);
if (!imgSrc) {
for (let r of it.rawNames) {
imgSrc = getCustomImage(r);
if (imgSrc) break;
}
}
const finalImg = imgSrc || it.img;

thumb.className = 'thumb';
thumb.dataset.naonaoId = it._naonao_id || '';
thumb.dataset.kikiyxId = it._kikiyx_id || '';
thumb.dataset.zxwId = it._zxw_id || '';
thumb.dataset.displayLabel = displayLabel;

thumb.innerHTML = `<div class="thumb-img-container"><img alt="${displayLabel}" src="${finalImg || ''}" loading="lazy" />
</div>
<div class="label">${displayLabel}</div>`;
thumb.onclick = () => {
const key = thumb.dataset.displayLabel;
if (selected[key]) {
selected[key].count++;
} else {
selected[key] = {
count: 1,
naonaoId: thumb.dataset.naonaoId,
kikiyxId: thumb.dataset.kikiyxId,
zxwId: thumb.dataset.zxwId,
rawNames: Array.from(it.rawNames)
};
}
updateThumbDisplay(thumb, key);
updateSelectedUI();
};
container.appendChild(thumb);
});
};



/* CATALOG SPECIFIC SEARCH LOGIC */
const performSearch = () => {
const selectedKeys = Object.keys(selected).filter(k => selected[k].count > 0);
if (selectedKeys.length === 0) {
renderResults([]);
return;
}

const server = document.getElementById('serverSelect')?.value || '';
const promises = [];

if (API_SOURCES['naonao'].enabled) {
let c = [];
selectedKeys.forEach(k => {
if (selected[k].naonaoId) {
for (let i = 0; i < selected[k].count; i++) c.push(selected[k].naonaoId); } }); const
    sid=window._naonaoServerMap?.[server] || '' ; let url = API_SOURCES['naonao'].url + (API_SOURCES['naonao'].url.includes('?') ? '&' : '?') + 'action=search';
if (server) url += '&server=' + encodeURIComponent(server);
url += '&key=' + encodeURIComponent(c.join(','));
promises.push(fetch(url).then(r => r.json()).catch(() => ({ results: [] })));



    } else {
    promises.push(Promise.resolve(null));
    }
if (API_SOURCES['kikiyx'].enabled) {
let c = [];
selectedKeys.forEach(k => {
if (selected[k].kikiyxId) {
for (let i = 0; i < selected[k].count; i++) c.push(selected[k].kikiyxId); } }); const
    sid=window._kikiyxServerMap?.[server] || '' ; const params = new URLSearchParams();
params.append('action', 'search');
c.forEach(id => params.append('cards', id));
if (server) params.append('server', server);

promises.push(fetch(API_SOURCES['kikiyx'].url, {
method: 'POST',
headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
body: params.toString()
}).then(r => r.json()).catch(() => ({ results: [] })));



    } else {
    promises.push(Promise.resolve(null));
    }
if (API_SOURCES['zxw'].enabled) {
let c = [];
selectedKeys.forEach(k => {
if (selected[k].zxwId) {
for (let i = 0; i < selected[k].count; i++) c.push(selected[k].zxwId); } }); const
    sid=window._zxwServerMap?.[server] || '' ; if (sid) c.push(sid);
let url = API_SOURCES['zxw'].url + (API_SOURCES['zxw'].url.includes('?') ? '&' : '?') + 'action=search';
url += '&key=' + encodeURIComponent(c.join(','));
promises.push(fetch(url).then(r => r.json()).catch(() => ({ results: [] })));


    } else {
    promises.push(Promise.resolve(null));
    }

    Promise.all(promises).then(responses => {
    const combinedResults = [];
    let idx = 0;

    {
    const raw = responses[idx++];
    if (raw) {
    let items = getResultsArray(raw, 'naonao');
    
    if (server && 'naonao' !== 'zxw') {
    items = items.filter(d => {
    let di = {};
    try { di = typeof d.deck_info === 'string' ? JSON.parse(d.deck_info) : d.deck_info; } catch (e) { }
    return di && Object.keys(di).some(k => normalizeString(k, API_SOURCES['naonao'].prefixes) === server);
    });
    }
    
    items = items.filter(acc => accountMatchesSelection(buildHasMap(acc), selectedKeys));
    items.forEach(item => {
    item._src = 'naonao';
    item._p = API_SOURCES['naonao'].priority;
    combinedResults.push(item);
    });
    }
    }    {
    const raw = responses[idx++];
    if (raw) {
    let items = getResultsArray(raw, 'kikiyx');
    
    if (server) {
    items = items.filter(d => d.cards && String(d.cards).includes(server));
    }
    
    items = items.filter(acc => accountMatchesSelection(buildHasMap(acc), selectedKeys));
    items.forEach(item => {
    item._src = 'kikiyx';
    item._p = API_SOURCES['kikiyx'].priority;
    combinedResults.push(item);
    });
    }
    }    {
    const raw = responses[idx++];
    if (raw) {
    let items = getResultsArray(raw, 'zxw');
    
    if (server && 'zxw' !== 'zxw') {
    items = items.filter(d => {
    let di = {};
    try { di = typeof d.deck_info === 'string' ? JSON.parse(d.deck_info) : d.deck_info; } catch (e) { }
    return di && Object.keys(di).some(k => normalizeString(k, API_SOURCES['zxw'].prefixes) === server);
    });
    }
    
    items = items.filter(acc => accountMatchesSelection(buildHasMap(acc), selectedKeys));
    items.forEach(item => {
    item._src = 'zxw';
    item._p = API_SOURCES['zxw'].priority;
    combinedResults.push(item);
    });
    }
    }
    renderResults(combinedResults);
    }).catch(e => {
    console.error('Search error:', e);
    renderResults([]);
    });
    };


/* CATALOG SPECIFIC RESULT CONTROLLER */
/* ====== RESULT CONTROLLER (Multi-API AKE) ====== */
const renderResults = (results) => {
allSearchResults = results;
renderedCount = 0;
const res = document.querySelector("#results");
if (res) res.innerHTML = '';
renderBatch();
};

const sortResults = (criteria) => {
if (criteria === 'priority') {
allSearchResults.sort((a, b) => (a._p || 99) - (b._p || 99));
} else if (criteria === 'price-asc') {
allSearchResults.sort((a, b) => (a.price || 0) - (b.price || 0));
} else if (criteria === 'price-desc') {
allSearchResults.sort((a, b) => (b.price || 0) - (a.price || 0));
}
renderedCount = 0;
const res = document.querySelector("#results");
if (res) res.innerHTML = '';
renderBatch();
};
const renderBatch = () => {
const res = document.querySelector("#results");
if (!res) return;

const nextBatch = allSearchResults.slice(renderedCount, renderedCount + BATCH_SIZE);

nextBatch.forEach(item => {
const card = document.createElement("div");
card.className = "result-card";

const source = item._src || 'Unknown';
const config = API_SOURCES[source];

// 1. Resolve ID (Apply Obfuscation)
const rawId = item.id || item[config.idKey] || "N/A";
const displayId = rawId !== "N/A" ? privateToPublicID(String(rawId), source) : "N/A";

// 2. Resolve Server & Metadata
let serverName = "Global";
let info = [];
let emailFound = false;

if (source === 'naonao') {
const config = API_SOURCES['naonao'];
{
let s = '', g = '', l = '';
const di = item.deck_info ? (typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info) : {};
Object.keys(di || {}).forEach(k => {
const normK = normalizeString(k, config.prefixes);
if (['Asia', 'Global'].includes(normK)) {
s = normK;
serverName = normK;
}
if (k.includes('女')) g = 'Female';
if (k.includes('男')) g = 'Male';
});

const srcText = item.source || '';
const lm = srcText.match(/等级[:：]([0-9]+)/);
if (lm) l = lm[1];

if (g) info.push("Gender: " + g);
if (s) info.push("Server: " + s);
if (l) info.push("Level: " + l);
}
}
if (source === 'kikiyx') {
const config = API_SOURCES['kikiyx'];
{
let s = '', g = '', l = '';
const di = item.deck_info ? (typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info) : {};
Object.keys(di || {}).forEach(k => {
const normK = normalizeString(k, config.prefixes);
if (['Asia', 'Global'].includes(normK)) {
s = normK;
serverName = normK;
}
if (k.includes('女')) g = 'Female';
if (k.includes('男')) g = 'Male';
});

const srcText = item.source || '';
const lm = srcText.match(/等级[:：]([0-9]+)/);
if (lm) l = lm[1];

if (g) info.push("Gender: " + g);
if (s) info.push("Server: " + s);
if (l) info.push("Level: " + l);

if (item.cards && typeof item.cards === 'string') {
if (item.cards.includes('A01')) serverName = 'Asia';
else if (item.cards.includes('A02')) serverName = 'Global';
}
}
}
if (source === 'zxw') {
const config = API_SOURCES['zxw'];
{
let s = '', g = '', l = '';
const di = item.deck_info ? (typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info) : {};
Object.keys(di || {}).forEach(k => {
const normK = normalizeString(k, config.prefixes);
if (['Asia', 'Global'].includes(normK)) {
s = normK;
serverName = normK;
}
if (k.includes('女')) g = 'Female';
if (k.includes('男')) g = 'Male';
});

const srcText = item.source || '';
const lm = srcText.match(/等级[:：]([0-9]+)/);
if (lm) l = lm[1];

if (g) info.push("Gender: " + g);
if (s) info.push("Server: " + s);
if (l) info.push("Level: " + l);
}
}

// Default Email fallback for verification [F3]
if (!emailFound) {
info.push("Email: Microsoft");
}

// 3. Resolve Items Data
let has = {};
if (item.deck_info) {
try { has = typeof item.deck_info === 'string' ? JSON.parse(item.deck_info) : item.deck_info; } catch (e) { }
}

const charNames = Object.keys(has).filter(name => {
const norm = normalizeString(name, config.prefixes);
// Filter out server/meta cards from items grid [F5]
if (['Gender', 'Server', 'Email', 'Level', '性别', '区服'].some(ignore => norm.includes(ignore))) return false;
if (['Asia', 'Global', 'A01', 'A02'].some(ignore => norm === ignore)) return false;
return !config.unwanted.has(norm);
});

const charHTML = charNames.map(name => {
const count = has[name] || 1;
const std = translateName(normalizeString(name, config.prefixes));
const imgSrc = window._characterImageMap?.[std] || '';
return `
<div class="char">
    <div class="char-img-container">
        <img src="${imgSrc}" alt="${std}" title="${std}" loading="lazy" />
        ${count > 1 ? `<div class="char-count">x${count}</div>` : ''}
    </div>
    <div class="cname">${std}</div>
</div>
`;
}).join('');

// 4. Extended ID for Copying
const charString = charNames.flatMap(n => Array(has[n] || 1).fill(translateName(normalizeString(n,
config.prefixes)))).join(',');
const extendedId = `${displayId}----${serverName}----[${charString}]`;

const sourceLabel = config.idPrefix || source.toUpperCase();
const infoString = info.join(' | ');

card.innerHTML = `
<div class="result-header">
    <div>Account ID: <strong>${escapeHtml(displayId)}</strong></div>
    <div class="header-btns">
        <button class="copy-btn">Copy ID</button>
        <button class="price-btn">Price Check</button>
    </div>
</div>
<div class="result-info">${infoString} | Source: ${sourceLabel}</div>
<div class="chars-row">
    ${charHTML}
</div>
`;

// Event Listeners
card.querySelector('.copy-btn').onclick = () => copyToClipboard(extendedId);
card.querySelector('.price-btn').onclick = () => showPriceCheck(displayId, extendedId);

res.appendChild(card);
});

renderedCount += nextBatch.length;
if (renderedCount < allSearchResults.length) { const lastCard=res.lastElementChild; if (lastCard && resultObserver)
    resultObserver.observe(lastCard); } };

/* PRICE MODAL */
const initPriceModal = () => {
const modal = document.createElement('div');
modal.id = 'priceCheckModal';
modal.className = 'modal-backdrop hidden';
modal.innerHTML = `
<div class="modal-content">
    <div class="modal-header">
        <h3>Price Check Inquiry</h3>
        <button class="close-modal">&times;</button>
    </div>
    <div class="modal-body">
        <p class="step-header">Step 1: Copy Account ID</p>
        <div class="id-display-box highlighted">
            <span>Account ID:</span>
            <code id="modalAccountId">---</code>
            <input type="hidden" id="modalFullId" value="">
            <button class="copy-mini-btn" id="modalCopyBtn">Copy</button>
        </div>

        <div class="modal-divider"></div>

        <p class="step-header">Step 2: Choose Contact Method For Price Quotation</p>

        <div class="contact-row">
            <div class="contact-option primary">
                <div class="opt-icon">✨</div>
                <div class="opt-details">
                    <strong>Direct Message</strong>
                    <a href="https://discord.com/users/477359052662243349" target="_blank" class="modal-btn">DM
                        Admin</a>
                </div>
            </div>

            <div class="contact-option secondary">
                <div class="opt-icon">🌸</div>
                <div class="opt-details">
                    <strong>Join Server</strong>
                    <a href="https://discord.com/invite/exvg8GR8sk" target="_blank" class="modal-btn">Join &
                        DM CL</a>
                </div>
            </div>
        </div>
        <p class="modal-hint"
            style="text-align:center; margin-top:8px; font-size:0.8em; color:var(--text-muted); opacity:0.8;">
            (Discord Tag: <code>gachamacha2025</code>)
        </p>
    </div>
</div>
`;
document.body.appendChild(modal);

const closeBtn = modal.querySelector('.close-modal');
closeBtn.onclick = () => modal.classList.add('hidden');
modal.onclick = (e) => {
if (e.target === modal) modal.classList.add('hidden');
};

const cpBtn = modal.querySelector('#modalCopyBtn');
cpBtn.onclick = () => {
const fullId = document.querySelector('#modalFullId').value;
copyToClipboard(fullId);
cpBtn.textContent = 'Copied!';
setTimeout(() => cpBtn.textContent = 'Copy', 2000);
};
};

window.showPriceCheck = (id, fullId) => {
const modal = document.querySelector("#priceCheckModal");
if (!modal) return;
document.querySelector("#modalAccountId").textContent = id;
document.querySelector("#modalFullId").value = fullId || id;
modal.classList.remove('hidden');
};


/* INIT HANDLERS */
const sBtn = document.querySelector("#searchBtn");
if (sBtn) sBtn.onclick = performSearch;

const sortSel = document.querySelector("#sortSelect");
if (sortSel) sortSel.onchange = sortResults;

const cBtn = document.querySelector("#clearBtn");
if (cBtn) cBtn.onclick = () => {
selected = {};
document.querySelectorAll('.thumb').forEach(t =>
{t.classList.remove('selected'); t.querySelector('.count-badge')?.remove(); });
const idIn = document.querySelector("#idSearchInput");
if (idIn) idIn.value = '';
updateSelectedUI();
document.querySelector("#results").innerHTML = '';
};
window.copyToClipboard = copyToClipboard;
initPriceModal();
loadResources();

})();